import theme from 'styles/theme'

type Breakpoints = {
  sm?: string
  md?: string
  lg?: string
  xl?: string
  xxl?: string
}

const getBreakpointValue = (breakpoint: keyof Breakpoints): number => {
  const bp = theme._config.theme?.breakpoints?.[breakpoint]

  if (typeof bp !== 'string') {
    return -1
  }

  return Number(bp.slice(0, bp.length - 2)) // strip "px"
}

export const isBelowBreakpoint = (breakpoint: keyof Breakpoints): boolean => {
  const bpValue = getBreakpointValue(breakpoint)

  if (bpValue === -1) return false

  return typeof window !== 'undefined' && window.innerWidth < bpValue
}

export const isAboveBreakpoint = (breakpoint: keyof Breakpoints): boolean => {
  const bpValue = getBreakpointValue(breakpoint)

  if (bpValue === -1) return false

  return typeof window !== 'undefined' && window.innerWidth >= bpValue
}
